/**
 * This library works by providing the same interface as the History API.
 * 1. There is no extra processing if query params were not already present on page load.
 * 2. Clean the existing and new query strings, convert both to objects and merge.
 * 3. Reduce the merged object back to a valid param string and call the History API.
 */
(function() {
  function getOriginalDocumentLocationQuery() {
    if (document.location.hash && document.location.hash.indexOf('?') >= 0) {
      return document.location.hash.split('?')[1];
    }
    if (document.location.search.substring(0, 1) === '?') {
      return document.location.search.substring(1);
    }
    return false;
  }
  window.ELCHistory = {
    originalDocumentHref: window.location.href,
    originalDocumentLocationSearch: false,
    convertParamsToObject: function(params) {
      if (!params) {
        return {};
      }
      // Convert URL params to a JS Object
      // https://stackoverflow.com/a/8649003
      try {
        return JSON.parse('{"' + decodeURI(params).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
      } catch (e) {
      }
    },
    convertObjectToParams: function(obj) {
      if (!Object.keys(obj).length) {
        return '';
      }
      let finalString = '?';
      let firstRun = true;
      Object.keys(obj).forEach((key) => {
        if (!firstRun) {
          finalString += '&';
        }
        finalString += `${key}=${obj[key]}`;
        firstRun = false;
      });
      return finalString;
    },
    generateURL: function(url) {
      let oldFragments = this.originalDocumentHref.indexOf('?') >= 0 ? this.originalDocumentHref.split('?')[1] : '';
      let oldFragmentsObject = this.convertParamsToObject(oldFragments);

      let newBaseURL = url.indexOf('?') >= 0 ? url.split('?')[0] : url;
      let newFragments = url.indexOf('?') >= 0 ? url.split('?')[1] : '';
      let newFragmentsObject = this.convertParamsToObject(newFragments);

      let finalizedURLParams = this.convertObjectToParams({
        ...oldFragmentsObject,
        ...newFragmentsObject,
      });

      return newBaseURL + finalizedURLParams;
    },
    replaceState: function(stateObj, title, url) {
      if (!(url && url.length > 1) || !this.originalDocumentLocationSearch) {
        window.history.replaceState(stateObj, title, url);
      }
      window.history.replaceState(stateObj, title, this.generateURL(url));
    },
    pushState: function(stateObj, title, url) {
      if (!(url && url.length > 1) || !this.originalDocumentLocationSearch) {
        window.history.pushState(stateObj, title, url);
      }
      window.history.pushState(stateObj, title, this.generateURL(url));
    }
  };

  ELCHistory.originalDocumentLocationSearch = getOriginalDocumentLocationQuery();
})();
